var React = require('react');

function BrokenLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.44 3.44a1.5 1.5 0 012.12 0l6 6a1.5 1.5 0 11-2.12 2.12l-6-6a1.5 1.5 0 010-2.12zM9 16.5a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 110 3h-3A1.5 1.5 0 019 16.5zM22.5 3A1.5 1.5 0 0124 4.5v3a1.5 1.5 0 11-3 0v-3A1.5 1.5 0 0122.5 3zM27 13.5a1.5 1.5 0 011.5-1.5h9a10.5 10.5 0 110 21h-9a1.5 1.5 0 010-3h9a7.5 7.5 0 000-15h-9a1.5 1.5 0 01-1.5-1.5zm-16.5 8.271a1.5 1.5 0 010 2.122l-5.303 5.304a7.5 7.5 0 0010.606 10.606l5.304-5.304a1.5 1.5 0 112.122 2.122l-5.304 5.304a10.5 10.5 0 01-14.85-14.85l5.304-5.304a1.5 1.5 0 012.122 0z"}));
}

BrokenLink.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = BrokenLink;

BrokenLink.default = BrokenLink;
